import Cookies from 'js-cookie';

import { fetchCsrfInfo } from '@/App/apiWrapper';

interface CsrfInfo {
  cookieName: string | null;
  headerName: string | null;
}

class CsrfService {
  private static instance: CsrfService;

  private initialized: boolean = false;
  private csrfInfo?: CsrfInfo;

  private constructor() {}

  static getInstance(): CsrfService {
    if (!CsrfService.instance) {
      CsrfService.instance = new CsrfService();
    }
    return CsrfService.instance;
  }

  async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    }

    try {
      this.csrfInfo = await fetchCsrfInfo();
      this.initialized = true;
    } catch (error) {
      console.error('Failed to fetch CSRF info:', error);
    }
  }

  addCsrfToken(headers: Headers) {
    if (!this.csrfInfo) {
      return;
    }
    const csrfToken = Cookies.get(this.csrfInfo.cookieName!);
    if (csrfToken) {
      headers.append(this.csrfInfo.headerName!, csrfToken);
    }
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

const csrfService = CsrfService.getInstance();

export default csrfService;
